export const MIN_DISPLAYABLE_AVG_RATING = 3.0;

export const CAROUSEL_METADATA_COLLECTION_SLUG = {
  STACKABLE_DEGREES: 'stackable-degrees-metadata',
  STACKABLE_SPECIALIZATIONS: 'stackable-specializations-metadata',
};

export const TESTIMONIALS_CARD_WIDTH = 86;
export const CAREER_ROLE_CARD_WIDTH = 80;
export const LOHP_SLIDER_CARD_WIDTH = 91;

export default {};
